export const SYNC_BLOCK_PRODUCTS = ['confluence-page', 'jira-work-item'] as const;
